import React from 'react';
import PropTypes from 'prop-types';

import { HorseLink } from '../../../shared/links/ProfileLink';

const SireCell = ({
    sireName,
    sireCountryOriginCode,
    sireUid,
    sireOfDamName,
    sireOfDamCountryOriginCode,
    sireOfDamUid,
}) => (
    <div>
        <HorseLink
            className="ui-link_marked"
            horseStyleName={sireName}
            horseUid={sireUid}
        >
            {sireName} ({sireCountryOriginCode})
        </HorseLink>
        <br className="hidden-sm-down" />
        <HorseLink
            className="ui-link_marked"
            horseStyleName={sireOfDamName}
            horseUid={sireOfDamUid}
        >
            {sireOfDamName} ({sireOfDamCountryOriginCode})
        </HorseLink>
    </div>
);

SireCell.propTypes = {
    sireName: PropTypes.string,
    sireCountryOriginCode: PropTypes.string,
    sireUid: PropTypes.number,
    sireOfDamName: PropTypes.string,
    sireOfDamCountryOriginCode: PropTypes.string,
    sireOfDamUid: PropTypes.number,
};

export default SireCell;



// WEBPACK FOOTER //
// ./src/js/horse/progenySales/components/SireCell.jsx